import Row from './row';
import Col from './col';
export { Row, Col };


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.6.4@antd/es/grid/index.js
// module id = 122
// module chunks = 0